import dateFormat from "dateformat";

/* Date */
dateFormat.i18n = {
  dayNames: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  monthNames: ["En", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ag", "Sep", "Oct", "Nov", "Dic", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  timeNames: ["a", "p", "am", "pm", "A", "P", "AM", "PM"],
};

// MOB - I decided to include an id parameter to avoid issues with different languages (already was happening here between spanish and gallego
// Is it ok to use a more complex object here? Should we just use ID numbers for tag identification?
// export const sSearch = {
//   tagTitle: "Categorías",
//   tagExam: { label: "Exámenes", original: "Exames" },
//   tagIllness: { label: "Enfermedades", original: "Enfermidades" },
//   tagBodyOutside: { label: "Cuerpo: fuera", original: "Corpo: fora" },
//   tagBodyInside: { label: "Cuerpo: dentro", original: "Corpo: dentro" },
//   tagSymptoms: { label: "Síntomas", original: "Sintomas" },
//   tagTreatments: { label: "Tratamientos", original: "Tratamentos" },
//   tagHealthSystem: { label: "Sistema de salud", original: "Sistema de saude" },
//   tagOther: { label: "Otros", original: "Outros" }
// }


export const sSearch = {
  tagTitle: "Categorías",
  tagExam: { label: "Exámenes", original: "4_Exames" },
  tagIllness: { label: "Enfermedades", original: "5_Enfermidades" },
  tagBodyOutside: { label: "Cuerpo: fuera", original: "1_Corpo: fora" },
  tagBodyInside: { label: "Cuerpo: dentro", original: "2_Corpo: dentro" },
  tagSymptoms: { label: "Síntomas", original: "6_Sintomas" },
  tagTreatments: { label: "Tratamientos", original: "3_Tratamentos" },
  tagHealthSystem: { label: "Sistema de salud", original: "7_Sistema de saude" },
  tagOther: { label: "Otros", original: "Outros" }
}